export default {
  SET_USER_API_KEY(state, key) {
    state.userApiKey = key;
  },
  SET_USER_POINTS(state, points) {
    state.userPoints = points;
  },
  SET_USER_REWARDS(state, rewards) {
    state.userRewards = rewards;
  },
  SET_USER_WIN_REWARDS(state, rewards) {
    state.userWinRewards = rewards;
  },
};
